import { createContext, useState , useContext, useMemo} from "react";
import { GetIndice } from "../services/IndiceService";
import { getAccessTokenLocalStorage, ValidAccessTokenLocalStorage, handleUserLogOutErro } from "../context/utils"
import { UserPreferenceContext } from "../context/UserPreferenceContext"; 
import PropTypes from 'prop-types';


export const IndiceContext = createContext();

const IndiceProvider = ({ children }) => {
    const [indice, setIndice] = useState();
    const { userAuthenticated, setUserAuthenticated } = useContext(UserPreferenceContext);
    
    async function doIndice() {
        let token = getAccessTokenLocalStorage();
        if (ValidAccessTokenLocalStorage()) {
            await GetIndice(token
            ).then(res => {
                setIndice(res.data);
            })
                .catch(err => {
                    handleUserLogOutErro(err, userAuthenticated, setUserAuthenticated);
                });
        }
    };    
    
    const value = useMemo(() => ({
        indice,
        doIndice,
    }), [indice]);
    return (
        <IndiceContext.Provider
            value={ value }
        >
            {children}
        </IndiceContext.Provider>
    );
}
IndiceProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default IndiceProvider;